export default __webpack_public_path__ + "static/media/aadhar.cefec3d6.svg";